var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "home-footer-info",
      staticStyle: { height: "100%" },
      attrs: { id: "current-client", "justify-end": "", "align-center": "" }
    },
    [
      _c("span", [_vm._v("Weezie Fiber ")]),
      _vm._v(" "),
      _c("v-icon", { staticClass: "px-1", attrs: { size: "12" } }, [
        _vm._v(" copyright ")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "pr-4" }, [_vm._v(_vm._s(_vm.currentYear))]),
      _vm._v(" "),
      _vm.client
        ? _c("span", { staticStyle: { "padding-left": "2px" } }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("LicensedTo")) +
                " " +
                _vm._s(_vm.client) +
                "\n  "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75cdb860", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75cdb860","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Footer/CurrentClient.vue
// module id = null
// module chunks = 